import appStyle from '../../styles/Modal.module.scss';
import { Col, Row } from 'react-bootstrap';
import React from 'react';

const AlertModalScore = ({ categoryResult, scores, categories, categoryGroups, onClose }) => {

  const screenerMessage = () => {
    return (
      <div>
        <p className="font-poppins font-14 text-color-gray text-center">
          {categoryResult.label.find(item => item.variable === "title")?.value}
        </p>
        <p className="font-poppins font-14 text-color-gray">
          <strong>
            {decodeURIComponent(categoryResult?.label?.find(item => item.variable === "highlight")?.value ?? '')}
          </strong>
          {decodeURIComponent(categoryResult?.label?.find(item => item.variable === "description")?.value ?? '')}
        </p>

        <button onClick={onClose} className="custom-button-default w-100">
          OK
        </button>
      </div>
    );
  };

  const screenerMessageGrouped = () => {
    // Variable to hold the group with min=-1
    let noMatchedGroup = null;

    // Filter out groups with no matching categories and handle min=-1
    const validGroups = categoryGroups
      .map((group) => {
        let groupWithCategories = {
          groupLabel: group.label,
          groupMin: group.min,
          groupCategories: [],
        };

        categories.forEach((category) => {
          const categoryScore = scores.get(category.min);
          if (
            categoryScore !== undefined &&
            categoryScore >= group.min &&
            categoryScore <= group.max
          ) {
            groupWithCategories.groupCategories.push(category);
          }
        });

        return groupWithCategories;
      })
      .filter((group) => {
        // If groupMin is -1, assign it to noMatchedGroup and exclude from validGroups
        if (group.groupMin === -1) {
          noMatchedGroup = group;
          return false; // Exclude from validGroups
        }
        return group.groupCategories.length > 0;
      })
      .sort((a, b) => a.groupMin - b.groupMin);

    console.log('Valid Groups:', validGroups);
    console.log('No Matched Group (min=-1):', noMatchedGroup);

    return (
      <div>
        {validGroups.length > 0 ? (
          validGroups.map((group, idx) => (
            <div key={idx}>
              <p className="font-poppins font-14 text-color-gray text-center">
                {group?.groupLabel?.find((item) => item.variable === "header")?.value ?? ''}
              </p>
              {/* If there's no description, show comma-separated highlights */}
              {group.groupCategories.some((category) =>
                category?.label?.find((item) => item.variable === "description")
              ) ? (
                group.groupCategories.map((category, index) => (
                  <div key={index} className="font-poppins font-14 text-color-gray">
                    <p>
                      <strong>{category?.label?.find((item) => item.variable === "highlight")?.value ?? ''}</strong>
                      {decodeURIComponent(category?.label?.find((item) => item.variable === "description")?.value ?? '')}
                    </p>
                  </div>
                ))
              ) : (
                <p className="font-poppins font-14 text-color-gray">
                  <strong>
                    {group.groupCategories
                      .map(
                        (category) =>
                          category?.label?.find((item) => item.variable === "highlight")?.value ?? ''
                      )
                      .join(", ")}
                  </strong>
                  {decodeURIComponent(group?.groupLabel?.find((item) => item.variable === "footer")?.value ?? '')}
                </p>
              )}
            </div>
          ))
        ) : noMatchedGroup && (
          <div>
            <p className="font-poppins font-14 text-color-gray text-center">
              {noMatchedGroup?.groupLabel?.find((item) => item.variable === "header")?.value ?? ''}
            </p>
            <p className="font-poppins font-14 text-color-gray text-center">
              {noMatchedGroup?.groupLabel?.find((item) => item.variable === "footer")?.value ?? ''}
            </p>
          </div>
        )}

        <button onClick={onClose} className="custom-button-default w-100">
          OK
        </button>
      </div>
    );

  };


  return (
    <>
      <div className={appStyle['card-modal']}>
        {categoryResult ? screenerMessage() : screenerMessageGrouped()}
      </div>
    </>
  );
};

export default AlertModalScore;
